<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：服务信息
  -->
  <div class="pb50">
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">报备信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col>
            <div class="pb16">
              <span class="gray9">订单ID：</span>
              {{ detail.order_master && detail.order_master.report ? detail.order_master.report.orderId : '' }}
            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">报备类型：</span>
              <span style="color:red">
                {{ detail.order_master && detail.order_master.report ? detail.order_master.report.type_text : '' }}
              </span>

            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">图片信息：</span>
              <!-- <img v-if="detail.report.images" :src=" 'data:image/png;base64,'  + detail.report.images" alt="暂无图片" width="100" height="100"> -->
              <img v-if="detail.order_master && detail.order_master.report && detail.order_master.report.images"
                :src="detail.order_master.report.images" alt="" width="60px" height="60px">
            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">报备时间：</span>
              {{ detail.order_master && detail.order_master.report ? detail.order_master.report.createTime : '' }}
            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">报备内容：</span>
              <span style="color:red">
                {{ detail.order_master && detail.order_master.report ? detail.order_master.report.content : '' }}
              </span>
            </div>
          </el-col>
        </el-row>

      </div>

    </div>

  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { deepClone } from "@/utils/base.js";
export default {
  props: ["detail"],
  data() {
    return {};
  },
  created(e) { },
  methods: {}
};
</script>
<style lang="scss" scoped>
.img {
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/refund/part/report.vue